module.exports = __webpack_public_path__ + "img/ranking2.bad8e414.png";